import { push } from '@lagunovsky/redux-react-router'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { H_CAMPAIGN_INSTALLATION_TRACKING } from '../../../account/constants/AccessRulesConstants'
import CampaignAction from '../../../campaign/actions/CampaignAction'
import CampaignTracking from '../../../campaign/components/campaignTracking/CampaignTracking'
import CampaignDto from '../../../campaign/dto/CampaignDto'
import { componentHasHabilitations } from '../../../utils/HabilitationUtil'
import DtoInstallation from '../../dto/installation/DtoInstallation'


class InstallationCampaignTrackingApp extends Component {
    componentDidMount = () => {
        if (!componentHasHabilitations(H_CAMPAIGN_INSTALLATION_TRACKING)) { // A modifier quand react-router sera à jour
            this.props.push('/unauthorized')
            return
        }
        this.props.fetchInstallationCampaignEvent(this.props.params.id)
    }

    componentDidUpdate = prevProps => {
        if (this.props.params.id !== prevProps.params.id) {
            this.props.fetchInstallationCampaignEvent(this.props.params.id)
        }
    }

    render = () => (
        <CampaignTracking
            params={this.props.params}
            stations={this.props.installationsLight}
            stationType='installation'
        />
    )
}

InstallationCampaignTrackingApp.propTypes = {
    params: PropTypes.shape({
        id: PropTypes.string,
    }),
    campaign: PropTypes.instanceOf(CampaignDto),
    installationsLight: PropTypes.arrayOf(PropTypes.instanceOf(DtoInstallation)),
    push: PropTypes.func,
    fetchInstallationCampaignEvent: PropTypes.func,
}

const mapStateToProps = store => ({
    campaign: store.CampaignReducer.campaign,
    installationsLight: store.InstallationReducer.installationsLight,
})

const mapDispatchToProps = {
    fetchInstallationCampaignEvent: CampaignAction.fetchInstallationCampaignEvent,
    push,
}

export default connect(mapStateToProps, mapDispatchToProps)(InstallationCampaignTrackingApp)